export default {
  "app.pwa.offline": "當前處於離線狀態",
  "app.pwa.serviceworker.updated": "有新內容",
  "app.pwa.serviceworker.updated.hint": "請點選“重新整理”按鈕或者手動重新整理頁面",
  "app.pwa.serviceworker.updated.ok": "重新整理",
};
